import {
  SecurityBySymbolInfoFragment,
  SecurityPerformanceBySymbolFragment,
} from 'generated/types'
import { getMarketDetails } from 'pages/invest/core/fund/segment'
import { getPlatform } from 'utils/platform'

export const BitcoinWTDNCardButtonTapped = (feedContext: string) => ({
  feature: 'Bitcoin WTDN Card',
  event_description: 'Bitcoin WTDN CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinWTDNCTA',
  screen: feedContext,
  screen_name: feedContext,
})

export const BitcoinEntryCardButtonTapped = (
  investmentProduct: string,
  portfolioTheme: string,
  portfolioRisk: string,
  subscriptionTier: string,
) => ({
  feature: 'Bitcoin Entry Card',
  event_description: 'Bitcoin Entry Card CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinEntryCardCTA',
  screen: 'portfolio',
  screen_name: 'portfolio',
  investment_product: investmentProduct,
  portfolio_theme: portfolioTheme,
  portfolio_risk: portfolioRisk,
  subscription_tier: subscriptionTier,
})

export const BitcoinLanderViewed = (investmentProduct: string) => ({
  feature: 'Bitcoin Onboarding',
  event_description: 'Bitcoin Lander Viewed',
  platform: getPlatform(),
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'bitcoinLander',
  screen: 'bitcoinLander',
  screen_name: 'bitcoinLander',
  investment_product: investmentProduct,
})

export const BitcoinLanderButtonTapped = (investmentProduct: string) => ({
  feature: 'Bitcoin Onboarding',
  event_description: 'Bitcoin Lander Add To Your Portfolio CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinAddToYourPortfolioCTA',
  screen: 'bitcoinLander',
  screen_name: 'bitcoinLander',
  investment_product: investmentProduct,
})

export const BitcoinLanderModalButtonTapped = (investmentProduct: string) => ({
  feature: 'Bitcoin Onboarding',
  event_description: 'Bitcoin Add To Your Portfolio Modal CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinAddToYourPortfolioModalCTA',
  screen: 'bitcoinAddToYourPortfolioModal',
  screen_name: 'bitcoinAddToYourPortfolioModal',
  investment_product: investmentProduct,
})

export const BitcoinOnboardingSuccessViewed = (investmentProduct: string) => ({
  feature: 'Bitcoin Onboarding',
  event_description: 'Success Screen Viewed',
  platform: getPlatform(),
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'bitcoinOnboardingSuccess',
  screen: 'bitcoinOnboardingSuccess',
  screen_name: 'bitcoinOnboardingSuccess',
  investment_product: investmentProduct,
})

export const BitcoinFundDetailsRemoveButtonTapped = (
  investmentProduct: string,
  portfolioTheme: string,
  portfolioRisk: string,
  subscriptionTier: string,
  securityInfo: SecurityBySymbolInfoFragment | undefined | null,
  securityPerformance: SecurityPerformanceBySymbolFragment | undefined | null,
  ytdReturn: number | undefined,
) => ({
  feature: 'Bitcoin Fund Details',
  event_description: 'Bitcoin Fund Details Remove CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinFundDetailsRemoveCTA',
  screen: 'FundDetail',
  screen_name: 'FundDetail',
  investment_product: investmentProduct,
  portfolio_theme: portfolioTheme,
  portfolio_risk: portfolioRisk,
  subscription_tier: subscriptionTier,
  ...getMarketDetails(securityInfo, securityPerformance, ytdReturn),
})

export const BitcoinFundDetailsRemoveModalButtonTapped = {
  feature: 'Bitcoin Onboarding',
  event_description: 'Bitcoin Remove From Your Portfolio Modal CTA Tapped',
  platform: getPlatform(),
  Object: 'Button',
  Action: 'Tapped',
  object_name: 'bitcoinRemoveFromYourPortfolioModalCTA',
  screen: 'bitcoinRemoveFromYourPortfolioModal',
  screen_name: 'bitcoinRemoveFromYourPortfolioModal',
}

export const BitcoinRemovedSuccessViewed = {
  feature: 'Bitcoin Removal',
  event_description: 'Success Screen Viewed',
  platform: getPlatform(),
  Object: 'Screen',
  Action: 'Viewed',
  object_name: 'bitcoinRemovalSuccess',
  screen: 'bitcoinRemovalSuccess',
  screen_name: 'bitcoinRemovalSuccess',
}
